<template>
  <div class="card" v-if="result">
    <div class="card-header">
      <div class="flex justify-between items-center">
          <h2 class="card-heading">ETA</h2>
        <div class="card-subheading px-4 py-2">
          {{
            showLess
                ? "Showing:" + result.length + "/" + result.length
                : "Total:" + result.length
          }}
        </div>
      </div>
    </div>
    <div class="card-content">
      <p v-if="result.length === 0" class="text-center text-xs text-slate-700">No ETA's Available</p>
        <div v-if="!showLess" class="grid grid-cols-1 md:grid-cols-3 gap-2">
          <div
              class="eta-card"
              v-for="item in result"
              v-bind:key="item.pos"
          >
            <div class="h-full bg-slate-200 rounded-lg">
              <div class="content p-3">
                <p class="font-medium text-slate-700">
                  <i class="fal text-slate-700 text-xl fa-ship mb-2 mr-1"></i
                  >{{ item.vessel_name }}
                </p>
                <p class="text-xs text-blue-600">ETA: {{ item.eta.substring(0, 10) }}</p>
                <p class="text-xs text-blue-600">{{ item.sourceport_name }}</p>
                <p class="text-xs text-blue-600">Agent: {{ item.agent_name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showLess" class="grid grid-cols-1 md:grid-cols-3 gap-2">
          <div
              class="eta-card"
              v-for="item in result.slice(0, 3)"
              v-bind:key="item.pos"
          >
            <div class="h-full bg-slate-200 rounded-lg">
              <div class="content p-3">
                <p class="font-medium text-slate-700">
                  <i class="fal text-slate-700 text-xl fa-ship mb-2 mr-1"></i
                  >{{ item.vessel_name }}
                </p>
                <p class="text-xs text-blue-600">
                  ETA: {{ item.eta.substring(0, 10) }}
                </p>
                <p class="text-xs text-blue-600">{{ item.sourceport_name }}</p>
                <p class="text-xs text-blue-600">Agent: {{ item.agent_name }}</p>
              </div>
            </div>
          </div>
        </div>
      <div class="text-center">
        <span
            v-if="showLess"
            class="text-xs text-gray-600 hover:text-blue-600 cursor-pointer"
            @click="showLess = false"
        >View All</span
        >
        <span
            v-if="!showLess"
            class="text-xs text-gray-600 hover:text-blue-600 cursor-pointer"
            @click="showLess = true"
        >Hide</span
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";

@Component({
  components: {},
})
export default class EstimatedArrival extends Vue {
  private service = new BandharuService();
  private loading = false;
  private showLess = true;

  private etaships: any = [
    {
      type: "General Cargo Vessel",
      name: "VB Progress",
      eta: "ETA: 27th January 2021",
      image:
          "https://www.joc.com/sites/default/files/field_feature_image/Container%20ship%20sailing%20with%20sun%20in%20background.jpg",
    },
    {
      type: "Container Vessel",
      name: "MV HANSA BREITENBURG",
      eta: "ETA: 27th January 2021",
      image:
          "https://www.marineinsight.com/wp-content/uploads/2016/07/Depositphotos_61067349_original-copy-1.jpg",
    },
    {
      type: "Container Vessel",
      name: "MV IBERIAN EXPRESS",
      eta: "ETA: 27th January 2021",
      image:
          "https://www.maritime-executive.com/media/images/article/Photos/Vessels_Large/Original/cosco-shipping-aries-container-ship.64b375.jpg",
    },
  ];

  private result = null;

  mounted() {
    this.getEstimatedArrivals();
  }

  getEstimatedArrivals() {
    this.service
        .getEta()
        .then((res) => {
          this.result = res;
          this.loading = false;
        })
        .catch((error) => {
          console.log("Error");
          this.loading = false;
        });
  }
}
</script>
